/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Audio_OkInputs */

const en_tut_audio_ok = /** @type {(inputs: Tut_Audio_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The label becomes **Mendengar rekan di sekitar**, and while you speak, **Mikrofon aktif · rekan terdekat dapat mendengar**.`)
};

const id_tut_audio_ok = /** @type {(inputs: Tut_Audio_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Label berubah menjadi **Mendengar rekan di sekitar**, dan saat berbicara menjadi **Mikrofon aktif · rekan terdekat dapat mendengar**.`)
};

/**
* | output |
* | --- |
* | "The label becomes **Mendengar rekan di sekitar**, and while you speak, **Mikrofon aktif · rekan terdekat dapat mendengar**." |
*
* @param {Tut_Audio_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_audio_ok = /** @type {((inputs?: Tut_Audio_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Audio_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_audio_ok(inputs)
	return en_tut_audio_ok(inputs)
});